import { render, staticRenderFns } from "./CustomRedirects.vue?vue&type=template&id=0fbb1f73&"
import script from "./CustomRedirects.vue?vue&type=script&lang=js&"
export * from "./CustomRedirects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports